import React from 'react';
import styled from 'styled-components';
import Grid from 'styled-components-grid';

// we need to filter out the dark prop because it isn't accepted by the DOM
const TabBar = styled(({dark, ...props}) => <Grid {...props} />)`
  margin: 0 ${({theme}) => theme.spacingHorizontal(-1)} ${({theme}) => theme.spacingVertical()};
  > *:first-child {
    padding-left: ${({theme}) => theme.spacingHorizontal()};
  }
  > *:last-child {
    padding-right: ${({theme}) => theme.spacingHorizontal()};
  }
  > * + * {
    border-left: 2px solid ${({theme, dark}) => (dark ? theme.white : theme.primaryColor)};
  }
`;

export default TabBar;
